import React from 'react';
import { Rating } from '@mui/material';

export function Stars({ value }: { value: number | null }) {
    const v = typeof value === 'number' ? Math.max(0, Math.min(5, Math.round(value))) : 0;
    return <Rating value={v} readOnly size="small" sx={{ color: '#f59e0b' }} />;
}

export function formatWhen(it: any) {
    if (!it) return '';
    const ts = it.lastFeedbackAtMs || it.lastStartAtMs || it.updatedAt || it._createdAt || it.createdAt || it.interviewCompletedAt;
    if (!ts) return '';
    try {
        if (typeof ts === 'number') return new Date(ts).toLocaleString();
        if (ts && typeof ts.toDate === 'function') return ts.toDate().toLocaleString();
        if (ts && ts._seconds) return new Date(ts._seconds * 1000).toLocaleString();
        return new Date(ts).toLocaleString();
    } catch (e) {
        return '';
    }
}
